// @flow
import type {Node} from 'react'
import React, {useMemo} from 'react'
import DiffComponent from 'components/proposals/Part/ui/DiffComponent'
import ListItem from 'components/proposals/Part/ui/Summary/ListItem'
import Value from 'components/proposals/Part/ui/Value'

type Props = $ReadOnly<{
  value: Value,
}>

function DiffItem({value}: Props): Node {
  const type = useMemo(() => {
    if (value.isNew)
      return 'adding'

    if (value.isDeleted)
      return 'removing'

    return 'changing'
  }, [value])

  return (
    <ListItem type={type}>
      <DiffComponent htmlDiff={value.htmlDiff} />
    </ListItem>
  )
}

export default DiffItem
